import * as fs from "fs";
import * as os from "os";

function readNumberFromFile(file: string): number {
    return Number(fs.readFileSync(file, "utf-8"));
}

function readAllNumbersFromFile(file: string): number[] {
    return fs
        .readFileSync(file, "utf-8")
        .split(" ")
        .map(i => Number(i));
}

export function getCpuLimits(): number {
    if (process.platform !== "linux") {
        return getCpuLimitFromOs();
    }
    return getCpuLimitFromEnv() ?? getCpuLimitFromCgroup() ?? getCpuLimitFromOs();
}

function getCpuLimitFromOs(): number {
    // eslint-disable-next-line no-console
    console.log(`Use cpu limit from os.cpus`);
    return os.cpus().length;
}

function getCpuLimitFromEnv(): number | null {
    try {
        const concurrencyLimit = Number(process.env.BUILD_CANDY_FORM_CONCURRENCY_LIMIT);

        if (!isNaN(concurrencyLimit) && concurrencyLimit > 0) {
            // eslint-disable-next-line no-console
            console.log(`Use cpu limit from environment BUILD_CANDY_FORM_CONCURRENCY_LIMIT`);
            return concurrencyLimit;
        }

        return null;
    } catch {
        return null;
    }
}

function getCpuLimitFromCgroup(): number | null {
    try {
        const cpuLimits = readAllNumbersFromFile("/sys/fs/cgroup/cpu.max");
        const cpuCfsQuotaUs = cpuLimits[0];
        const cpuCfsPeriodUs = cpuLimits[1];
        return calculateCpuLimit(cpuCfsQuotaUs, cpuCfsPeriodUs, "cgroup v2");
    } catch (e1) {
        // eslint-disable-next-line no-console
        console.log(`Don't use limit from cgroup v2`, e1);
        try {
            const cpuCfsQuotaUs = readNumberFromFile("/sys/fs/cgroup/cpu/cpu.cfs_quota_us");
            const cpuCfsPeriodUs = readNumberFromFile("/sys/fs/cgroup/cpu/cpu.cfs_period_us");
            return calculateCpuLimit(cpuCfsQuotaUs, cpuCfsPeriodUs, "cgroup");
        } catch (e2) {
            // eslint-disable-next-line no-console
            console.log(`Don't use limit from cgroup`, e2);
            return null;
        }
    }
}

function calculateCpuLimit(
    cpuCfsQuotaUs: number | undefined,
    cpuCfsPeriodUs: number | undefined,
    type: string
): number {
    if (cpuCfsQuotaUs && cpuCfsPeriodUs) {
        const cpuLimit = cpuCfsQuotaUs / cpuCfsPeriodUs;
        if (cpuLimit > 0) {
            // eslint-disable-next-line no-console
            console.log(`Use cpu limit from ${type}`);
            return cpuLimit;
        }
    }
    throw new Error(`${type} is not use`);
}
